package com.alpha.showcase.common.cache.dao

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.util.appendPlaceholders
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.alpha.showcase.common.cache.entity.GallerySourceMedia
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlin.text.StringBuilder

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class GallerySourceMediaDao_Impl(
  __db: RoomDatabase,
) : GallerySourceMediaDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfGallerySourceMedia: EntityInsertAdapter<GallerySourceMedia>
  init {
    this.__db = __db
    this.__insertAdapterOfGallerySourceMedia = object : EntityInsertAdapter<GallerySourceMedia>() {
      protected override fun createQuery(): String = "INSERT OR IGNORE INTO `gallery_source_media` (`id`,`source_name`,`media_uri`,`display_name`,`mime_type`,`added_at`) VALUES (nullif(?, 0),?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: GallerySourceMedia) {
        statement.bindLong(1, entity.id)
        statement.bindText(2, entity.sourceName)
        statement.bindText(3, entity.mediaUri)
        statement.bindText(4, entity.displayName)
        statement.bindText(5, entity.mimeType)
        statement.bindLong(6, entity.addedAt)
      }
    }
  }

  public override suspend fun insertOrIgnore(items: List<GallerySourceMedia>): List<Long> = performSuspending(__db, false, true) { _connection ->
    val _result: List<Long> = __insertAdapterOfGallerySourceMedia.insertAndReturnIdsList(_connection, items)
    _result
  }

  public override suspend fun getBySource(sourceName: String): List<GallerySourceMedia> {
    val _sql: String = """
        |
        |        SELECT * FROM gallery_source_media
        |        WHERE source_name = ?
        |        ORDER BY added_at ASC, id ASC
        |        
        """.trimMargin()
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, sourceName)
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfSourceName: Int = getColumnIndexOrThrow(_stmt, "source_name")
        val _columnIndexOfMediaUri: Int = getColumnIndexOrThrow(_stmt, "media_uri")
        val _columnIndexOfDisplayName: Int = getColumnIndexOrThrow(_stmt, "display_name")
        val _columnIndexOfMimeType: Int = getColumnIndexOrThrow(_stmt, "mime_type")
        val _columnIndexOfAddedAt: Int = getColumnIndexOrThrow(_stmt, "added_at")
        val _result: MutableList<GallerySourceMedia> = mutableListOf()
        while (_stmt.step()) {
          val _item: GallerySourceMedia
          val _tmpId: Long
          _tmpId = _stmt.getLong(_columnIndexOfId)
          val _tmpSourceName: String
          _tmpSourceName = _stmt.getText(_columnIndexOfSourceName)
          val _tmpMediaUri: String
          _tmpMediaUri = _stmt.getText(_columnIndexOfMediaUri)
          val _tmpDisplayName: String
          _tmpDisplayName = _stmt.getText(_columnIndexOfDisplayName)
          val _tmpMimeType: String
          _tmpMimeType = _stmt.getText(_columnIndexOfMimeType)
          val _tmpAddedAt: Long
          _tmpAddedAt = _stmt.getLong(_columnIndexOfAddedAt)
          _item = GallerySourceMedia(_tmpId,_tmpSourceName,_tmpMediaUri,_tmpDisplayName,_tmpMimeType,_tmpAddedAt)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteBySourceAndUris(sourceName: String, mediaUris: List<String>) {
    val _stringBuilder: StringBuilder = StringBuilder()
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("        DELETE FROM gallery_source_media")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("        WHERE source_name = ")
    _stringBuilder.append("?")
    _stringBuilder.append(" AND media_uri IN (")
    val _inputSize: Int = mediaUris.size
    appendPlaceholders(_stringBuilder, _inputSize)
    _stringBuilder.append(")")
    _stringBuilder.append("""
        |
        |""".trimMargin())
    _stringBuilder.append("        ")
    val _sql: String = _stringBuilder.toString()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, sourceName)
        _argIndex = 2
        for (_item: String in mediaUris) {
          _stmt.bindText(_argIndex, _item)
          _argIndex++
        }
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteBySource(sourceName: String) {
    val _sql: String = """
        |
        |        DELETE FROM gallery_source_media
        |        WHERE source_name = ?
        |        
        """.trimMargin()
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, sourceName)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
